const replaceHyphenBlankString = (stringValue) => {
    if (!stringValue) {
        return " - ";
    }
    if (stringValue?.toString().trim() === "") {
        return " - ";
    }
    return stringValue;
}

export {replaceHyphenBlankString};